import { Grid } from "@material-ui/core";
import React from "react";
import FormikTextField from "./FormikTextField";

export default function NameFields({
  namePrefix = "",
  idPrefix = "",
  labelPrefix = "",
  firstNameRequired = false,
  lastNameRequired = false,
  includeMiddleName = true,
  size = "medium",
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={includeMiddleName ? 4 : 6}>
        <FormikTextField
          idPrefix={idPrefix}
          name={namePrefix + (!namePrefix || namePrefix.endsWith(".") ? "firstName" : "FirstName")}
          label={(labelPrefix ? labelPrefix + " " : "") + "First Name"}
          required={firstNameRequired}
          size={size}
          maxLength={100}
        />
      </Grid>
      {includeMiddleName && (
        <Grid item xs={12} md={4}>
          <FormikTextField
            idPrefix={idPrefix}
            name={namePrefix + (!namePrefix || namePrefix.endsWith(".") ? "middleName" : "MiddleName")}
            label={(labelPrefix ? labelPrefix + " " : "") + "Middle Name"}
            size={size}
            maxLength={100}
          />
        </Grid>
      )}
      <Grid item xs={12} md={includeMiddleName ? 4 : 6}>
        <FormikTextField
          idPrefix={idPrefix}
          name={namePrefix + (!namePrefix || namePrefix.endsWith(".") ? "lastName" : "LastName")}
          label={(labelPrefix ? labelPrefix + " " : "") + "Last Name"}
          required={lastNameRequired}
          size={size}
          maxLength={100}
        />
      </Grid>
    </Grid>
  );
}
